import { render, staticRenderFns } from "./DescriptionTypeSelect.vue?vue&type=template&id=f4fd99d6&scoped=true&lang=pug"
import script from "./DescriptionTypeSelect.vue?vue&type=script&lang=js"
export * from "./DescriptionTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fd99d6",
  null
  
)

export default component.exports